import { Construction, Mail } from "lucide-react";

export default function Maintenance() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md space-y-6">
        <div className="mx-auto w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
          <Construction className="w-10 h-10 text-primary" />
        </div>
        <h1 className="text-3xl font-bold text-foreground">
          Em Manutenção
        </h1>
        <p className="text-muted-foreground text-lg">
          Estamos realizando melhorias no Liberaê. Voltaremos em breve com novidades!
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Mail className="w-4 h-4" />
          <span>contato@liberae.com.br</span>
        </div>
      </div>
    </div>
  );
}
